import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from "@material-ui/core";
import { COLORS } from '../Theme'

import axios from "axios";
import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SIcon } from "../Icon";
import { Theme } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';

import { headadmin as v_headadmin, basic, Values, SNACKBAR_TIME } from '../../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({

    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '230px 1fr',
    },
    sidebar: {
        display: 'grid',
        gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
        backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '60px 1fr',
    },
    title: {
        margin: 'auto 0px auto 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: `${COLORS.WHITE}`,
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& img": {
            width: 'auto',
            maxHeight: '50%',
            margin: '10px',
        },
        "& #name": {
            display: 'inline-block',
            margin: 'auto 0px auto 0px',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
    },
    userinfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& #name": {
            display: 'inline-block',
            fontFamily: 'NanumR',
            fontSize: '1.25rem',
            fontWeight: 'bolder',
        },
    },
    menu: {
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& ul": {
            marginTop: '10px',
            "& li": {
                fontSize: '1rem',
                fontWeight: 'bolder',
                color: `${COLORS.SLATE_GREY}`,
                "& ul": {
                    listStyle: 'none',
                    paddingLeft: '0px',
                    "& li": {
                        fontSize: '1rem',
                        fontWeight: 'normal',
                        margin: '0px',
                        cursor: 'pointer',
                    }
                }
            }
        }
    },
    info: {
        fontFamily: 'NanumR',
        fontSize: '2vw',
        fontWeight: 'bold',
        color: `${COLORS.CHARCHOAL_GREY}`,
        marginBottom: '10vh',
        marginTop: '-10vh',
    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr',
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    form: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        gap: '5%',
        "& input": {
            width: '70%',
            height: '55%',
        },
        "& Button": {
            border: 'solid 1px',
        }
    },
    classList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    buttonTable: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        margin: '0 10px',
    },
    buttonTable2: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        margin: '0 10px',
    },
    classInfo: {
        display: 'grid',
        gridTemplateColumns: '3fr 6fr 3fr 3fr',
        padding: '25px 0',
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    textLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    buttonLabel: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    infoButton: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: `${COLORS.CHARCHOAL_GREY}`,
        backgroundColor: `${COLORS.WATER_BLUE}`,
        borderRadius: '10px',
        margin: '0.5vh',
        width: '15vw',
        height: '45vh',
    },
    deleteButton: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: `${COLORS.CHARCHOAL_GREY}`,
        backgroundColor: `${COLORS.PUMPKIN}`,
        borderRadius: '10px',
        margin: '0.5vh',
        width: '15vw',
        height: '45vh',
    },
    buttonFont: {
        color: `${COLORS.WHITE}`,
        fontSize: '3vw'
    },
}));

type iClassList = {
    class_code: string,
    class_name: string,
    class_country: string,
    reg_date: string,
}

const HeadAdminClassManageNav: React.FC<any> = props => {

    const classes = useStyles();
    let history = useHistory();
    const state: any = history.location.state
    const classCode = state.code;
    const className = state.name;
    const [classStatus, setClassStatus] = useState<any>()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { member } = props;

    const updateStatus = (classStatus: any) => {
        console.log(classStatus)
        axios({
            method: "POST",
            data: {
                classCode: classCode,
                classStatus: classStatus
            },
            withCredentials: true,
            url: SERVER + v_headadmin.headadmin + v_headadmin.update_status,

            headers: { "Access-Control-Allow-Origin": basic.server_url, mode: 'cors', "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept" }
        })
            .then((res) => {
                return res.data
            })
            .then((data: any) => {
                console.log(data)
                if (data.code == Values.SUCCESS_CODE) {
                    selectStatus();
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
                    }
                }
            })
    }

    const selectStatus = () => {
        let url = new URL(SERVER + v_headadmin.headadmin + v_headadmin.search_status);
        let params = { 'classCode': classCode.toString() }
        url.search = new URLSearchParams(params).toString();
        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
            headers: { "Access-Control-Allow-Origin": basic.server_url, mode: 'cors', "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept" }
        })
            .then((res) => {
                return res.data
            })
            .then((data: any) => {
                console.log('data?', data)
                if (data.code == Values.SUCCESS_CODE) {
                    console.log(data.data[0].class_status)
                    if (data.data[0].class_status == "wait") {
                        setClassStatus("교육전")
                    }
                    if (data.data[0].class_status == "ing") {
                        setClassStatus("교육중")
                    }
                    if (data.data[0].class_status == "finish") {
                        setClassStatus("교육 완료")
                    }
                }
            })
    }

    const moveMaterialList = () => {
        history.push('/headAdminMaterialList')
    }
    const moveProductList = () => {
        history.push('/headAdminLicenseList')
    }
    const moveClassList = () => {
        history.push('/headAdminClassList')
    }
    const moveClassManage = () => {
        history.push('/headAdminClassManage')
    }
    const moveMemberList = () => {
        history.push('/headAdminMemberList')
    }
    const moveAccountManage = () => {
        history.push('/headAdminAccountManage')
    }

    const moveModifyPage = () => {
        console.log(classCode)
        console.log(className)
        history.push({
            pathname: '/headAdminModifyClass',
            state: {  // location state
                code: classCode,
                name: className,
            },
        })
    }

    const moveInfoPage = () => {
        console.log(classCode)
        console.log(className)
        history.push({
            pathname: '/headAdminClassMember',
            state: {  // location state
                code: classCode,
                name: className,
            },
        })
    }

    const moveStartPage = () => {
        console.log(classCode)
        console.log(className)
        history.push({
            pathname: '/headAdminClassRun',
            state: {  // location state
                code: classCode,
                name: className,
            },
        })
    }

    useEffect(() => { selectStatus() }, [])

    if (classStatus == "교육전") {
        return (
            <div className={classes.background}>
                <CssBaseline />
                <div className={classes.content}>
                    <div className={classes.sidebar}>
                        <div className={classes.logo} onClick={(e) => moveClassList()}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                        </div>
                        <div className={classes.userinfo}>
                            <Typography id="name">{member.name}님, 환영합니다!</Typography>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    품목 관리
                                    <ul>
                                        <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                        <li onClick={(e) => moveProductList()}>제품 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    교육 관리
                                    <ul>
                                        <li onClick={(e) => moveClassList()}>교육 목록</li>
                                        <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    회원 관리
                                    <ul>
                                        <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                        <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={classes.mainPage}>
                        <div className={classes.navigator}>
                            <div className={classes.title}>교육 관리 메뉴</div>
                            <div className={classes.form}>
                            </div>
                        </div>
                        <div className={classes.classList}>
                            <Typography className={classes.info}>
                                현재 접속 중인 메뉴의 교육명은 {className}입니다. <br></br>
                                현재 교육 상태는 {classStatus}입니다.
                            </Typography>
                            <div className={classes.buttonTable2}>
                                <div></div>
                                <div></div>
                                <Button
                                    onClick={(e) => updateStatus("ing")}
                                    className={classes.infoButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />시작하기
                                    </Typography>
                                </Button>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else if (classStatus == "교육중") {
        return (
            <div className={classes.background}>
                <CssBaseline />
                <div className={classes.content}>
                    <div className={classes.sidebar}>
                        <div className={classes.logo} onClick={(e) => moveClassList()}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                        </div>
                        <div className={classes.userinfo}>
                            <Typography id="name">{member.name}님, 환영합니다!</Typography>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    품목 관리
                                    <ul>
                                        <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                        <li onClick={(e) => moveProductList()}>제품 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    교육 관리
                                    <ul>
                                        <li onClick={(e) => moveClassList()}>교육 목록</li>
                                        <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    회원 관리
                                    <ul>
                                        <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                        <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={classes.mainPage}>
                        <div className={classes.navigator}>
                            <div className={classes.title}>교육 관리 메뉴</div>
                            <div className={classes.form}>
                            </div>
                        </div>
                        <div className={classes.classList}>
                            <Typography className={classes.info}>
                                현재 접속 중인 메뉴의 교육명은 {className}입니다. <br></br>
                                현재 교육 상태는 {classStatus}입니다.
                            </Typography>
                            <div className={classes.buttonTable}>
                                <Button
                                    onClick={(e) => moveStartPage()}
                                    className={classes.infoButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />진행하기
                                    </Typography>
                                </Button>
                                <Button
                                    onClick={(e) => moveModifyPage()}
                                    className={classes.deleteButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />수정하기
                                    </Typography>
                                </Button>
                                <Button
                                    onClick={(e) => moveInfoPage()}
                                    className={classes.infoButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />인원조회
                                    </Typography>
                                </Button>
                                <Button
                                    onClick={(e) => updateStatus("finish")}
                                    className={classes.deleteButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />종료하기
                                    </Typography>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (classStatus == '교육 완료') {
        return (
            <div className={classes.background}>
                <CssBaseline />
                <div className={classes.content}>
                    <div className={classes.sidebar}>
                        <div className={classes.logo} onClick={(e) => moveClassList()}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                        </div>
                        <div className={classes.userinfo}>
                            <Typography id="name">{member.name}님, 환영합니다!</Typography>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    품목 관리
                                    <ul>
                                        <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                        <li onClick={(e) => moveProductList()}>제품 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    교육 관리
                                    <ul>
                                        <li onClick={(e) => moveClassList()}>교육 목록</li>
                                        <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    회원 관리
                                    <ul>
                                        <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                        <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={classes.mainPage}>
                        <div className={classes.navigator}>
                            <div className={classes.title}>교육 관리 메뉴</div>
                            <div className={classes.form}>
                            </div>
                        </div>
                        <div className={classes.classList}>
                            <Typography className={classes.info}>
                                현재 접속 중인 메뉴의 교육명은 {className}입니다. <br></br>
                                현재 교육 상태는 {classStatus}입니다.
                            </Typography>
                            <div className={classes.buttonTable2}>
                                <div></div>
                                <div></div>
                                <Button
                                    onClick={(e) => moveInfoPage()}
                                    className={classes.infoButton}>
                                    <Typography className={classes.buttonFont}>
                                        교육<br />인원조회
                                    </Typography>
                                </Button>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className={classes.background}>
                <CssBaseline />
                <div className={classes.content}>
                    <div className={classes.sidebar}>
                        <div className={classes.logo} onClick={(e) => moveClassList()}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                        </div>
                        <div className={classes.userinfo}>
                            <Typography id="name">{member.name}님, 환영합니다!</Typography>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    품목 관리
                                    <ul>
                                        <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                        <li onClick={(e) => moveProductList()}>제품 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    교육 관리
                                    <ul>
                                        <li onClick={(e) => moveClassList()}>교육 목록</li>
                                        <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.menu}>
                            <ul>
                                <li>
                                    회원 관리
                                    <ul>
                                        <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                        <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={classes.mainPage}>
                        <div className={classes.navigator}>
                            <div className={classes.title}>교육 관리 메뉴</div>
                            <div className={classes.form}>
                            </div>
                        </div>
                        <div className={classes.classList}>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeadAdminClassManageNav;